import { RootState } from "../store"
import axios from "axios"

const headerMiddleware = (store: any) => (next: any) => (action: any) => {
    // Redux store'dan mevcut state'i al
    const currentState: RootState = store.getState()

    // Header bilgisini güncelle
    updateHeader(currentState)

    // Sonraki middleware'e veya reducer'a devam et
    return next(action)
}

// Redux store'daki state'e göre header bilgisini güncelleyen fonksiyon
function updateHeader(state: RootState) {
    // Redux store'dan gerekli bilgileri alarak header objesini oluştur
    const accessToken = state.auth.accessToken



    if (accessToken) {
        // Axios interceptor'ı kullanarak header objesini güncelle
        axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken
        axios.defaults.headers.common["Accept"] = "*/*"
    }
    else {
        // Header bilgilerini kaldır
        delete axios.defaults.headers.common["Authorization"];
        delete axios.defaults.headers.common["Accept"];
    }

}

export default headerMiddleware

export { }